const login = [{
    path: '/login',
    meta: {
        title: "登录"
    },
    component: () => import("@/views/login.vue")
}];
export default login;